import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Container from '../Container';
import FlexGrid from '../FlexGrid';
import styles from './Constraint.css';
var cx = classnames.bind(styles); // TODO: align the props with the container and grid props in a way that makes more sense

export default function Constraint(_ref) {
  var centered = _ref.centered,
      children = _ref.children,
      className = _ref.className,
      padded = _ref.padded,
      mobile = _ref.mobile,
      tablet = _ref.tablet,
      desktop = _ref.desktop,
      rest = _objectWithoutProperties(_ref, ["centered", "children", "className", "padded", "mobile", "tablet", "desktop"]);

  var columnProps = {
    mobile: mobile,
    tablet: tablet,
    desktop: desktop
  };
  return React.createElement(Container, _extends({
    className: cx({
      noPadding: !padded
    }, className),
    fluid: true
  }, rest), React.createElement(FlexGrid, null, React.createElement(FlexGrid.Column, _extends({
    className: cx({
      centered: centered
    })
  }, columnProps), children)));
}
Constraint.propTypes = {
  /** Centers the content provided in the children prop */
  centered: PropTypes.bool,

  /** Content that will be constrained */
  children: PropTypes.node,

  /** Custom class name to be applied to the component */
  className: PropTypes.string,

  /** Boolean value indicating whether to apply extra padding to the sides of the component */
  padded: PropTypes.bool,

  /** Responsive width constraint value for mobile devices. 12 = 100% width */
  mobile: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Responsive width constraint value for tablet devices. 12 = 100% width */
  tablet: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /** Responsive width constraint value for desktop devices. 12 = 100% width */
  desktop: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12])
};
Constraint.defaultProps = {
  centered: false,
  children: undefined,
  className: undefined,
  padded: false,
  mobile: undefined,
  tablet: undefined,
  desktop: undefined
};